declare global {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Window {
        require: (
            path: string | string[],
            successCallback: (result: any) => void,
            errorCallback: (error: any) => void
        ) => void;
        cacheBusters: { [id: string]: string };
    }
}

function requireSingleAsync(modulePath: string): Promise<any> {
    return new Promise((resolve, reject) => {
        window.require(
            [modulePath],
            function onSuccess(result: any) {
                resolve(result);
            },
            function onError(err: any) {
                reject(err);
            }
        );
    });
}

function requireAsync(modules: string[]): Promise<any[]> {
    return new Promise((resolve, reject) => {
        window.require(
            modules,
            function onSuccess(...params: any[]) {
                resolve(params);
            },
            function onError(err: any) {
                reject(err);
            }
        );
    });
}

function undef(path: string) {
    (window.require as any).undef(path);
}

function addPaths(paths: object) {
    (window.require as any).config({
        paths: paths
    });
}

function setCacheBuster(path: string, cacheBuster: string) {
    window.cacheBusters[path] = cacheBuster;
}

function getCacheBuster(path: string) {
    return window.cacheBusters[path];
}

export default {
    requireSingleAsync: requireSingleAsync,
    requireAsync: requireAsync,
    undef: undef,
    addPaths: addPaths,
    setCacheBuster: setCacheBuster,
    getCacheBuster: getCacheBuster
};
